export enum LOCAL_STORAGE {
    EDITING_SHIFT_STORE = 'editingShiftStore',
    SUBMISSION = 'submission',
    SHARED_SCHEDULE = 'sharedSchedule',
    SHARED_SCHEDULE_CODE = 'sharedScheduleCode',
}
